import React from "react";
import axios from "axios";

import {ModelPortfolioResource, parseResponse} from "../../../../../../../../utils/api";
import {displayErrorSnackBar} from "../../../../../../../../components/SnackbarProvider/actions";
import {getErrorMessage} from "../../../../../../../../utils/utils";

let cancelToken;
const useAssetSelectionSearch = (extraFilters, dispatch) => {

  const [assetsSearch, setAssetsSearch] = React.useState({
    data: undefined,
    loading: false,
    errors: undefined,
    date: Date.now()
  });

  const searchAssets = React.useCallback(async (filters, resolve, errors) => {
    //Check if there are any previous pending requests
    if (typeof cancelToken != 'undefined') {
      cancelToken.cancel("Operation canceled due to new request.");
    }
    //Save the cancel token for the current request
    cancelToken = axios.CancelToken.source();
    let response = {};
    try {
      response = await ModelPortfolioResource.searchAssets(filters, cancelToken.token);
    } catch (errors) {
      dispatch(displayErrorSnackBar(getErrorMessage(errors)));
    }
    parseResponse(response, 'assets', resolve, errors)
  }, []);

  const addExtraFilters = (filters) => {
    if(extraFilters){
      filters = {...filters, ...extraFilters};
    }

    return filters;
  };

  const handleSearchActivate = (value, onlyFavorite) => {

    if (value) {
      let filters = addExtraFilters({
        "name": value,
        "only_favorite": onlyFavorite
      });

      setAssetsSearch({
        data: undefined,
        loading: true,
        errors: undefined,
        date: Date.now()
      });

      try {
        searchAssets(filters, (data) => {
          setAssetsSearch({
            data,
            loading: false,
            errors: undefined,
            date: Date.now()
          });
        }, (errors) => {
          setAssetsSearch({
            data: undefined,
            loading: false,
            errors,
            date: Date.now()
          });
        });

      } catch (errors) {
        if (!axios.isCancel(errors)){
          setAssetsSearch({
            ...assetsSearch,
            loading: false,
            errors
          })
        }
      }
    } else {
      //Check if there are any previous pending requests
      if (typeof cancelToken != 'undefined') {
        cancelToken.cancel("Operation canceled due to new request.");
      }
      setAssetsSearch({
        loading: false,
        errors: undefined,
        data: [],
        date: Date.now()
      })
    }
  };

  return [assetsSearch, handleSearchActivate, addExtraFilters];
};

export default useAssetSelectionSearch;